import React from 'react'
import { Updater, Widget, any, async, fromJSX, nothing } from 'widgets-for-react'
import { CourseDetailsBlockLayout } from './courseDetailsBlockLayout'
import { CourseDetailsState, CourseDetailsStateUpdaters, EventAlternative } from './courseDetailsBlockState'
import { EventTemplate } from '../../../models/Events/Events'

export type CourseDetailsBlock = {
  state: CourseDetailsState
}

export const courseDetailsBlockWidget = (
  block: CourseDetailsBlock,
  page?: number
): Widget<Updater<CourseDetailsState>> => {
  const { pageData, eventData, alternativeEvents } = block.state
  return any([
    async<EventTemplate>(block.state.eventData).map(CourseDetailsStateUpdaters.updateEventData),
    async<EventAlternative[]>(block.state.alternativeEvents).map(CourseDetailsStateUpdaters.updateAlternativeEvents),
    eventData.kind == "loaded" && alternativeEvents.kind == "loaded"
      ? fromJSX(() =>
          <CourseDetailsBlockLayout
            pageData={pageData}
            eventTemplate={eventData.value}
            alternatives={alternativeEvents.value}
            page={page}
          />)
      : nothing()
  ])
}
